  <template>
  <div class="runtask">
    <BasiceLayout
      title="任务类型解析"
      class="bonus-code-layout "
    >
      <div class="tips-wrap margin-20">
        <pre>网络要求：所有任务均推荐三大运营商网络。<br>稳定性要求：所有任务均需要保证在其特定的高峰期稳定在线，否则会影响收益。</pre>
      </div>
      <div class="qa-item margin-20">
        <div class="question">
          <span class="faq-icon">Q</span>
          <el-select
            class="faq-tip-background revenue-select"
            v-model="value"
            @change="changeAnswer"
          >
            <el-option
              v-for="item in questions"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </div>
        <div class="answer revenue-answer">
          <span class="faq-icon answer-icon">A</span>
          <div class="faq-tip-background">
            <div class="tipContent answerContent">
              <div v-html="answer"></div>
            </div>
          </div>
        </div>
      </div>
    </BasiceLayout>
  </div>
  <!-- </div> -->
</template>

<script>
import BasiceLayout from "@/components/Common/BasicLayout.vue";
import { desc } from "@/config/RunTaskDes.js";

export default {
  name: "FAQ",
  components: {
    BasiceLayout,
  },
  props: {
    FAQ: "",
  },
  data() {
    return {
      options: this.questions,
      answers: {
        "A任务 ": "（1）全天工作任务，开放选择时间为每月26日到次月5日，选择任务后需要7天时间同步数据才可正常运行。<br/>\
        （2）每日0：00-10：00为数据同步时间，数据同步时间宕机会影响后续几天运行情况。<br/>\
        （3）每日18：00-24：00为晚高峰时间，晚高峰宕机会影响收益权重导致当日收益下降。<br/>\
        （4）A任务推荐使用IO性能较好的固态硬盘作为数据盘，机械盘上限较低。",
        "B任务": "（1）每日工作时间为晚高峰。<br/>\
        （2）晚高峰外其余时间不定期同步数据。<br/>\
        （3）每日18：00-24：00为晚高峰时间，晚高峰宕机会影响收益权重导致当日收益下降。<br/>\
        （4）B任务对硬盘IO性能要求较低，可以使用机械硬盘，该任务连接数较多，请谨慎选择。",
        "C任务": "（1）全天工作任务，不限制选择时间，选择后需要2-3天时间同步数据才可正常运行。<br/>\
        （2）全天不定时同步数据。<br/>\
        （3）每日18：00-24：00为晚高峰时间，晚高峰宕机会影响收益权重导致当日收益下降。<br/>\
        （4）C任务对硬盘IO性能要求较低，可以使用机械硬盘。<br/>\
        <p style='color: red;'>（5）C任务业务方要求开启ipv6网络，可提升节点利用率。<p>",
        "D任务": "（1）全天工作任务。<br/>\
        （2）全天不定时同步数据。<br/>\
        （3）每日18：00-24：00为晚高峰时间，晚高峰宕机会影响收益权重导致当日收益下降。<br/>\
        <p style='color: red;'>（4）D任务要求单线程上行带宽≥40M，若不达标会被判定为不可用设备导致无跑量。<p>",
        "F任务": "（1）每日工作时间为午高峰及晚高峰。<br/>\
        （2）高峰外其余时间不定期同步数据。<br/>\
        （3）F任务推荐使用IO性能较好的固态硬盘作为数据盘，机械盘上限较低。该任务连接数较多，可能导致光猫或路由器崩溃，请谨慎选择，或限制连接数上限。<br/>\
        （4）F任务需要任务和线路NAT1固定映射，一一对应，不支持upnp。",
        "H任务": "（1）支持全国所有地区及运营商<br/>\
        （2）每个任务线程要求1核/1G/50G硬盘起，硬盘推荐使用固态，机械看具体性能<br/>\
        （3）每个任务线程需要对应一条线路，出口IP 24小时内只允许发生一次拨号变更，不可重复变更，否则无法调度（具体软路由设置源IP等）<br/>\
        （4）必须有NAT1或者UPNP（推荐NAT1），否则无法调度，如果出口IP变化频繁，也会导致无法实现NAT1",
        "I任务": "（1）支持全国所有地区及运营商<br/>\
        （2）每个任务线程要求1核/1G/100G硬盘起，硬盘推荐使用固态，机械看具体性能<br/>\
        （3）电信联通必须有公网IP，移动必须有NAT1<br/>\
        （4）该任务为全天运行，不定时同步数据。",
      },
      questions: [
        "A任务",
        "B任务",
        "C任务",
        "D任务",
        "F任务",
        // "H任务",
        "I任务",
      ],
      value: "F任务 （推荐新手选择）",
      answer: '',
    };
  },
  created() {
    this.answer = this.answers[this.questions[4]];
        // this.text = res.data.replace(/\n/g, '<br>')

  },
  methods: {
    changeAnswer(val) {
      this.answer = this.answers[val];
    },
  },
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scopes lang="stylus">
.about-center {
  margin: 10px 0;
}

.revenue-select {
  min-width: 300px;
}

.faq-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 10px;
  // background-image: linear-gradient(-180deg, #15BCAD 2%, #10B2CB 100%)
  background: #0DB4C5;
  font-family: PingFangSC-Medium;
  font-size: 12px;
  color: #FFFFFF;
  text-align: center;
  line-height: 20px;
  margin: 10px 20px 0 0;
  vertical-align: bottom;
  position: absolute;
  left: 0;
}

.faq-tip-background {
  height: 30px;
  margin-left: 40px;
}

.tipIcon {
  display: inline-block;
  width: 0;
  height: 0;
  border: 3px solid transparent;
  border-bottom-color: #0DB4C5;
  border-right-color: #0DB4C5;
  vertical-align: bottom;
}

.tipContent {
  background: #0DB4C5;
  display: inline-block;
  font-size: 12px;
  color: #FFFFFF;
  line-height: 30px;
  padding: 0 20px;
  min-width: 70px;
  border-radius: 4px 4px 4px 0;
}

.faq-tip-background {
  display: inline-block;
}

.qa-item {
  margin-bottom: 22px;
}

.answer, .question {
  position: relative;
}

.answer-icon {
  font-size: 12px;
  color: #999B98;
  text-align: center;
  line-height: 18px;
  background: #F5F5F6;
}

.answerContent {
  color: #65686A;
  background: #F5F5F6;
  padding: 10px 20px;
}

.answer {
  margin: 18px 0 28px;
}

.answerIcon {
  border-bottom-color: #F5F5F6;
  border-right-color: #F5F5F6;
}

.bold {
  font-weight;
}

.revenue-answer {
  margin-top: 40px;
  margin-bottom: 60px;
}

.is-mobile {
  .runtask{
    .tips-wrap pre{
      white-space: pre-wrap;
    }
    .qa-item{
      margin: 0;

    }
    .faq-icon{
      display none;
    }
    .faq-tip-background{
      margin: 0;
      min-width: auto;
      margin: 0 0 0 20px;
    }
    .tipContent{
      min-width: auto;

    }
  }

}
</style>

